#import "../../../../graphql-wrappers/graphql/fragments/edition-fragment.graphql"

mutation SendEdition($edition: EditionSendInput!) {
    editionSend(input: $edition) {
        edition {
            ...EditionFragment
        }
    }
}
